module.exports = __webpack_public_path__ + "static/media/icon-user-group.76409f20.svg";